import type { RoofPath } from "@roof-hawk/core";

/**
 * The class that carries a path's colour, on the button and on the list.
 *
 * Shingle, metal and flat each have a colour, and every screen that offers the
 * choice uses the same one — the estimate generator and the two order
 * generators. Jonathon, 2026-08-24: "the visibility also wasn't obvious when he
 * selected shingles or metal so make that color coded please and more obvious."
 * Three screens picking their own colours would be worse than none.
 *
 * A map rather than a slug built from the label, because "Flat & Other" would
 * produce something with an ampersand in it, and because the pairing between
 * this and the rules in styles.css has to be visible in both files.
 */
export const PATH_CLASS: Record<RoofPath, string> = {
  Shingle: "path-shingle",
  Metal: "path-metal",
  "Flat & Other": "path-other",
  Siding: "path-siding",
  Decks: "path-deck",
};
